
const Urls = {
    PAYMENT_PORTAL_URL: '/your-orders-api/command/get-payment-fixup-widget?gqlOrderId=',
    PAYMENT_REDIRECT_URL: '/your-orders-api/command/payment-redirect?gqlOrderId='
}

export default Urls;